import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { UserService } from "src/app/core/services/user.service";
import { EGiftTransaction } from "src/app/shared/models/eGift/EGiftTransaction.model";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-e-gift-transaction-record",
	templateUrl: "./e-gift-transaction-record.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class EGiftTransactionRecordComponent implements OnInit {
	@Input() adHocTransaction: boolean = false;
	@Input() transactionSelected: EGiftTransaction;
	@Output() transactionEmitter: EventEmitter<EGiftTransaction> = new EventEmitter<EGiftTransaction>();
	@Output() editTransactionEmitter = new EventEmitter<EGiftTransaction>();

	clonedTransaction: EGiftTransaction;

	editTransaction: boolean = false;

	moment: any = moment;

	sendDateTime: string;
	sendOptions = [
		{
			label: "Send Now",
			value: false,
		},
		{
			label: "Send Later",
			value: true,
		},
	];

	user: User;

	constructor(private localStorage: LocalDataStoreService, private userService: UserService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.init();
	}

	async init() {
		if (this.adHocTransaction) {
			this.user = await this.localStorage.get("user");
			this.transactionSelected.purchaserFirstName = this.user.firstName;
			this.transactionSelected.purchaserLastName = this.user.lastName;
			this.transactionSelected.purchaserEmail = this.user.email;
		}
	}

	async createNewTransaction() {
		if (!this.transactionSelected.delaySend && this.transactionSelected.sendDateTime) {
			this.transactionSelected.sendDateTime = undefined;
		}
		this.transactionEmitter.emit(this.transactionSelected);
	}

	initEditTransaction() {
		this.clonedTransaction = { ...this.transactionSelected };
		this.editTransaction = true;
	}

	onDelaySendDateSelect() {
		this.transactionSelected.sendDateTime = moment(this.sendDateTime).toDate();
	}

	saveAction() {
		if (this.adHocTransaction) {
			this.createNewTransaction();
		} else {
			this.updateEGiftTransaction();
		}
	}

	updateEGiftTransaction() {
		this.clonedTransaction = undefined;
		this.editTransaction = false;
		const trxn = {
			key: this.transactionSelected.key,
			recipientName: this.transactionSelected.recipientName,
			recipientEmail: this.transactionSelected.recipientEmail,
			note: this.transactionSelected.note,
			sendDateTime: this.transactionSelected.sendDateTime,
		};

		this.focuslink.eGiftTransactionPatch(this.transactionSelected.venueKey, trxn);
		this.editTransactionEmitter.emit(this.transactionSelected);
	}
}
